export const UKPostalCode: RegExp =
  /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/;
export const email: RegExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
export const alphaNumericPattern: RegExp = /^[a-zA-Z0-9_ .-]*$/;
export const alphabet: RegExp = /^[A-Za-z\s]+$/;
export const phoneNumber = new RegExp(
  /^(?:(?:(?:00\s?|\+)44\s?|0\s?|)[123578](?:\s?\d){8,10})$/
);
export const addressPattern: RegExp = /^[a-zA-Z0-9_ ./,-]*$/;
